import BaseModule from "@core/modules/base-module/base-module";
import CdgMember from "@pj/components/cdg-member/cdg-member";
import moduleBackgroundImage from "@core/components/module-background-image/module-background-image";

import $ from "jquery";
//
const cdg = new BaseModule();
cdg.name = "cdg";
cdg.init(that => {
  moduleBackgroundImage(that.elements);

  that.elements.each(function() {
    $(this)
      .find(".cdg-member")
      .each(function() {
        const member = new CdgMember(this);
        member.init();
      });
  });
});
